<template>
  <div class="ty-main">
    <div class="ty-tip">
      <div class="ty-img">
        <img src="../../assets/images/prompt.png" />
      </div>

      <div class="tip">
        系统中的运行脚本报错提醒！
      </div>
    </div>
    <div class="ty-tabs">
      <template v-for="(item, index) in tabs">
        <div
          class="tab-item"
          :key="index"
          :class="{ active: tabIndex === index }"
          v-auth="[item.auth]"
          @click="changeTab(index)"
        >
          {{ item.title }}
        </div>
      </template>
      <!-- <div
        :style="tabindex === 0 ? 'border-bottom:3px solid #1152AD;color: #1152AD;' : ''"
        @click="tabclick(0)"
      >
        运行脚本
      </div>
      <div
        :style="tabindex === 1 ? 'border-bottom:3px solid #1152AD;color: #1152AD;' : ''"
        @click="tabclick(1)"
      >
        报错记录
      </div> -->
    </div>
    <div class="ty-content white" v-auth="['systemScript', 'systemErrorRecord']">
      <template v-if="tabIndex === 0">
        <el-table :data="tableData2" style="width: 100%;" id="table">
          <el-table-column label="时间" width="200px;" fixed>
            <template slot-scope="scope">
              <div class="okm">{{scope.row.created_at ? scope.row.created_at : '-'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="数据类型" width="200px;">
            <template slot-scope="scope">
              <div class="okm">{{scope.row.error_type ? scope.row.error_type : '-'}}</div>
            </template>
          </el-table-column>
          <el-table-column width="180px;">
            <template slot="header">
              风险等级
              <el-tooltip
                class="item"
                content="高风险会导致系统报错，中低风险不会影响系统运行"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row.level_type && scope.row.level_type !== ''">
                <span class="badge high" v-if="scope.row.level_type === 3"> 高</span>
                <span class="badge middle" v-if="scope.row.level_type === 2"> 中</span>
                <span class="badge" v-if="scope.row.level_type === 1"> 低</span>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="报错原因" min-width="474px;">
            <template slot-scope="scope">
              <div v-if="scope.row.content !== null && scope.row.content.length > 0">
                <el-popover
                  v-if="scope.row.content !== null && scope.row.content.length > 30"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <div>{{scope.row.content}}</div>
                  <span slot="reference" style="color: #303133;">{{scope.row.content | ellipsissss}}</span>
                </el-popover>
                <span v-else>{{scope.row.content}}</span>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty v-loading="loading"></el-empty>
          </template>
        </el-table>
      </template>
      <template v-else>
       <el-table :data="tableData" style="width: 100%;" id="table">
          <el-table-column label="数据类型" width="194" fixed>
           <template slot-scope="scope">
              <div class="okm">{{scope.row.name ? scope.row.name : '-'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="通知人" width="753">
            <template slot-scope="scope">
              <div v-if="scope.row.admim_user_name !== null && scope.row.admim_user_name.length > 0">
                <el-popover
                  v-if="scope.row.admim_user_name !== null && scope.row.admim_user_name.length > 10"
                  placement="top-start"
                  popper-class="popperBox"
                  trigger="hover">
                  <span v-for="(item, index) in scope.row.admim_user_name" :key="index">{{item}}，</span>
                  <span slot="reference" style="color: #303133;">
                    <span v-for="(item, index) in scope.row.admim_user_name.slice(0, 10)" :key="index">{{item}}<span v-show="index < scope.row.admim_user_name.length - 1">，</span>
                    </span>...<span>等{{scope.row.admim_user_name.length - 10}}人</span>
                  </span>
                </el-popover>
              <span v-else>
                  <span v-for="(item, index) in scope.row.admim_user_name" :key="index">{{item}}<span v-show="index < scope.row.admim_user_name.length - 1">，</span></span>
              </span>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope" v-if="tabIndex === 1">
              <el-button v-auth="['systemScriptEdit']" type="text" @click="editRow(scope.row)"
                >选择管理员</el-button
              >
            </template>
          </el-table-column>
          <template #empty>
            <el-empty v-loading="loading"></el-empty>
          </template>
        </el-table>
      </template>

      <div class="toolbar">
        <div></div>
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pagesize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="编辑" :visible.sync="isEditDialog" :show-close="false" :close-on-click-modal="false" :before-close="clearDialog" width="500px">
      <el-form class="dialog-form" label-width="80px">
        <el-form-item label="管理员">
          <el-input clearable v-model="administrator" @focus="openDepartement"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="isEditDialog = false">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="confirmEditRole()">确定</el-button>
      </div>
    </el-dialog>
    <!-- 选择员工 -->
    <el-dialog title="选择员工" :visible.sync="isSelectDialog" :show-close="false" :close-on-click-modal="false" width="600px" @open="clear">
      <el-row>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never" style="border-right: 1px solid #D8DCE1;">
            <el-input
              class="filter-input"
              placeholder="请输入人员名称"
              v-model="filterText"
              size="small"
              @input="dfhuh"
              @clear="gdfgf"
              clearable
            >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <div v-if="treeData01.length > 0 && treeData02.length === 0">
            <el-tree
              ref="tree"
              id="fixtree"
              :props="defaultProps"
              node-key="value"
              :check-on-click-node="true"
              :load="loadNode"
              :filter-node-method="filterNode"
              auto-expand-parent
              :check-strictly="true"
              lazy
              @check-change="getChecked">
              <span class="custom-tree-node" slot-scope="{ data, node }">
                  <span v-if="data.isDepartment === false">
                    <img class="organization-img" src="../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: #9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span>
                  </span>
                  <span v-if="data.isDepartment === true">
                    <img v-if="data.label" class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                    {{ data.label }}<span
                      v-if="node.checked && data.label"
                      style="margin-left: 10px;"
                      class="el-icon-check"
                    ></span>
                  </span>
                </span>
            </el-tree>
            </div>
            <ul class="infinite-lists" v-if="treeData02.length > 0" styel="z-index: 999;">
              <li v-for="(item, index) in treeData02" :key="index" @click="getChecked(item)" style="margin-left: -40px;text-align:left;margin-top:10px;">
                  <img class="organization-img" src="../../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                  <span style="margin-left:15px;">{{ item.label }} - {{ item.department_name}}</span>
              </li>
            </ul>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
            <div>已选择的员工</div>
             <ul class="infinite-list">
              <li v-for="item in checkedDimission" :key="item.id">
                <img class="organization-img" src="../../assets/images/user.png" style="width:14px;height:14px;" alt="">
                <div class="wqeq">{{ item.name }}</div>
                <div class="uiwe">
                  <i class="el-icon-close" @click="employeeClose(item)"></i>
               </div>
              </li>
          </ul>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="closee">取消</el-button>
        <el-button style="width: 72px;" type="primary" :disabled="disabled01" @click="reLoadTable">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { authList } from './config/authList.js'
export default {
  data() {
    return {
      tabs: [
        {
          title: '报错记录',
          auth: 'systemErrorRecord'
        },
        {
          title: '运行脚本',
          auth: 'systemScript'
        }

      ],
      tabIndex: 0,
      authList,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      tableData2: [],
      total: 0,
      isEditDialog: false,
      isSelectDialog: false,
      administrator: [],
      isDepartmentDialog: false,
      userId: [],
      loading: false,
      codeId: '',
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'value',
        isLeaf: 'isHasChildren'
      },
      treeData01: [],
      filterText: '',
      treeData02: [],
      disabled01: true,
      checkedDimission: []
    }
  },
  watch: {
    administrator() {
      if (!this.administrator) {
        this.userId = []
      }
    },
    filterText(val) {
      if (val) {
        this.$refs.tree.filter(val)
      } else {
        this.treeData01 = []
        this.sfhusi()
      }
    },
    checkedDimission(val) {
      if (val.length > 0) {
        this.disabled01 = false
      } else {
        this.disabled01 = true
      }
    },
    checkedDepartment(val) {
      if (val.length > 0) {
        this.disabled2 = false
      } else {
        this.disabled2 = true
      }
    }
  },
  beforeMount() {
    const authList = this.$store.state.authList
    if (authList.includes('systemErrorRecord') && !authList.includes('systemScript')) {
      this.tabIndex = 1
    }
  },
  mounted() {
    this.loading = true
    this.getCommand()
    this.tabIndex = 0
  },
  methods: {
    getList() {
      this.loading = true
      const params = {
        page: this.currentPage
      }
      this.$api.get('/api/v1/command/index', params).then((res) => {
        res.list.forEach(k => {
          k.admim_user_name = k.admim_user_name.split(',')
        })
        this.tableData = res.list
        this.total = res.total
        this.loading = false
      })
    },
    getCommand() {
      this.loading = true
      const params = {
        page: this.currentPage
      }
      this.$api.get('/api/v1/command/data', params).then((res) => {
        // res.list.forEach(v, (item) => {
        //   if(v.)
        // })
        this.total = res.total
        this.tableData2 = res.list
        this.loading = false
      })
    },
    confirmEditRole() {
      // this.userId = this.sendOutName.split(',')
      if (!this.userId.length) {
        this.$message.warning('管理员不能为空！')
        return false
      }
      this.$api
        .get('/api/v1/command/user', {
          code: this.codeId,
          admin_user: this.userId
        })
        .then((res) => {
            this.isEditDialog = false
            this.$message.success('修改成功')
            this.getList()
        })
    },
    currentChange(val) {
      this.tableData = []
      this.tableData2 = []
      this.currentPage = val
      if (this.tabIndex === 0) {
        this.getCommand()
      } else {
        this.getList()
      }
    },
    changeTab(index) {
      if (index !== this.tabIndex) {
        this.tableData = []
        this.tableData2 = []
        this.currentPage = 1
        if (index === 0) {
          this.tabIndex = index
          this.getCommand()
        } else {
          this.tabIndex = index
          this.getList()
        }
      }
    },
    clearDialog(done) {
      done()
    },
    openDepartement() {
      this.isSelectDialog = true
    },
    editRow(row) {
      this.codeId = row.code
      this.administrator = row.admim_user_name
      this.userId = row.admin_user.split(',')
      this.isEditDialog = true
    },
    async getEmployee(departmentId) {
      const res = await this.$api.get('/api/list/department/user', {
        department_id: departmentId
      })
      return res.data
    },
    loadNode(node, resolve) {
      if (node === undefined || node.level === 0) {
        this.chooseNode = node
        resolve(this.treeData01)
      } else {
        this.parent_id = node.data.value
        this.getChildrenNode()
        setTimeout(() => {
          resolve(this.treeData01)
        }, 1200)
      }
    },
    // 一级
    sfhusi() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        this.chooseNode = 0
        this.treeData01 = res.return_data
      })
    },
    // 二级
    getChildrenNode() {
      this.$api.post('/api/v1/test/get-department', {
        user_id: sessionStorage.getItem('user_id'),
        parent_id: this.parent_id
      }).then(res => {
        if (res.return_data.length === 0) {
          this.treeData01 = res.return_data
        } else {
          this.chooseNode = 0
          this.treeData01 = res.return_data
        }
      })
    },
    dfhuh() {
      this.$api.post('/api/v1/test/get-user-department', {
        user_id: sessionStorage.getItem('user_id'),
        name: this.filterText
      })
      .then(res => {
        if (res.length === 0 || res.user_data.length === 0) {
          this.treeData02 = []
          this.parent_id = 0
          this.sfhusi()
          // this.loadNode()
        } else {
          this.treeData02 = res.user_data
        }
      })
    },
    gdfgf() {
      this.filterText = ''
      this.treeData01 = []
      // this.sfhusi()
    },
    clear() {
       this.filterText = ''
       this.treeData02 = []
       this.treeData01 = []
       this.checkedDimission = []
       this.parent_id = 0
       this.sfhusi()
    },
    // tree过滤
    filterNode(value, data) {
      if (!value) return true
      return data.checkTitle.indexOf(value) !== -1
    },
    closee() {
      this.isSelectDialog = false
      this.filterText = ''
      this.getList()
    },
    reLoadTable() {
      const q = []
      this.filterText = ''
      if (this.checkedDimission.length > 0) {
          this.checkedDimission.forEach(v => {
            q.push(v.name)
            this.userId.push(v.id)
        })
        this.administrator = q.toString()
        this.currentPage = 1
        this.getList()
        this.isSelectDialog = false
      }
    },
    getChecked(value, isCheck) {
      this.userId = []
      if (value.isDepartment === true && value.value) {
        const checkedDimission = this.checkedDimission
        if (isCheck === false) {
          checkedDimission.forEach((item, i) => {
            if (item.id === value.value) {
              checkedDimission.splice(i, 1)
            }
          })
          return false
        }
        checkedDimission.forEach((item, i) => {
          if (item.id === value.value) {
            checkedDimission.splice(i, 1)
          }
        })
        if (value.department_name) {
           checkedDimission.push({
            id: value.value,
            name: value.label,
            show: 'false'
          })
        } else {
          checkedDimission.push({
            id: value.value,
            name: value.label
          })
        }
        this.checkedDimission = checkedDimission
      } else {
        return false
      }
    },
    employeeClose(value) {
      this.checkedDimission.forEach((item, i) => {
        if (item.id === value.id) {
          if (value.show) {
            this.checkedDimission.splice(i, 1)
          } else {
            this.checkedDimission.splice(i, 1)
            this.$refs.tree.setChecked(value.id, false, true)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.badge {
  font-size: 14px;
  color: #303133;
  line-height: 20px;

  &::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #303133;
    border-radius: 50%;
    vertical-align: middle;
  }

  &.high {
    color: #ee2928;

    &::before {
      background: #ee2928;
    }
  }

  &.middle {
    color: #ff9c40;

    &::before {
      background: #ff9c40;
    }
  }
  .ty-tabs .tab-item.active::before {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 5px;
    width: 80px;
    height: 3px;
    background: #204a9e;
    border-radius: 1px;
  }
}
.ty-tabs .tab-item.active::before {
  content: '';
  position: absolute;
  top: 77px;
  left: 5px;
  width: 80px;
  height: 3px;
  background: #204a9e;
  border-radius: 3px 3px 0px 0px;
}
::v-deep .ty-tabs .tab-item{
  margin-left: 20px;
}
::v-deep .el-dialog__body {
    padding: 0;
}
::v-deep .el-form-item__label{
  text-align: left;
}
::v-deep .el-button--primary.is-disabled{
  opacity: 0.7;
}
.filter-input {
  margin-bottom: 8px;
  line-height: 34px;
}
::v-deep .el-card{
  box-shadow: none;
  border-radius: 0;
}
.dialog-form{
  margin: 20px;
}
</style>
